import { FILES_SET_FILTERS } from "const/actionTypes";
import { AnyAction } from "@reduxjs/toolkit";
import { formatLocalDateNoMs } from "utils";

// "key": 743396,
// "original_filename": "lexico-195.219.39.9.pcap597963",
//  "client_ip": "195.219.39.9",
//  "source_from_client": "",
//  "source": "195.219.39.9",
//  "date_first": "2025-09-03T13:32:22.474902",
//  "date_last": "2025-09-03T13:32:29.533171",
//  "uploaded_at": "2025-09-03T13:33:34.331000",
//  "packets": 29904,
//  "calls": 6213

export interface FileItem {
    key: number;
    original_filename: string;
    client_ip: string;
    source_from_client: string;
    source: string;
    date_first: string;
    date_last: string;
    uploaded_at: string;
    packets: number;
    calls: number;
};

export interface FilesState {
    filters: {
        [key: string]: any;
    };
};


// Initial state
const now = new Date();

const endOfToday = new Date(now);
endOfToday.setHours(23, 59, 59, 999);

const startOfToday = new Date(now);
startOfToday.setDate(startOfToday.getDate());
startOfToday.setHours(0, 0, 0, 0);

const timeFrom = formatLocalDateNoMs(startOfToday);
const timeTo = formatLocalDateNoMs(endOfToday);


const initialState: FilesState = {
    filters: {
        time_from: timeFrom,
        time_to: timeTo,
        source: ""
    }
};


const handlers = {
    [FILES_SET_FILTERS]: (state: FilesState, action: AnyAction) => ({
        ...state,
        filters: {
            ...state.filters,
            ...action.payload
        }
    }),
    DEFAULT: (state: FilesState) => state
} as const;

// Reducer
const filesReducer = (state = initialState, action: AnyAction) => {
    const handle = handlers[action.type as keyof typeof handlers] || handlers.DEFAULT;
    return handle(state, action as any);
};

export default filesReducer; 